module.exports = __webpack_public_path__ + "static/kuhne-web-e708f12396f7fe6dcbf9e47d9bb41a6c.jpg";